import styled, { css } from 'styled-components';
import { ScInputStructure } from '@/components/form/structures/styled';
import { ThemeMode } from '@/helpers/enums';
import { device, hexToRGB, typography } from '@/styles/helpers';

interface ScPromoCodeInputProps {
  mode?: ThemeMode;
  inputPointerEventsNone?: boolean;
}

export const ScPromoCodeInput = styled.div<ScPromoCodeInputProps>`
  &.bonus-input {
    ${ScInputStructure} {
      background-color: #f2f2f4;
      padding-bottom: 8px;
      border-radius: 24px;

      @media (${device.mobile}) {
        background-color: ${({ theme }) => theme.color1};
      }
    }
    & .info-message {
      align-items: flex-start;
      flex-direction: column;
    }
  }


  & input {
    font-weight: 700;
    text-transform: uppercase;

    &::placeholder {
      text-transform: capitalize;
    }

    @media (${device.mobile}) {
      border-width: 1px;
    }
  }

  ${({ inputPointerEventsNone }) =>
    inputPointerEventsNone &&
    css`
      & input {
        pointer-events: none;
      }
    `}

  .info-message {
    display: flex;
    align-items: center;
    gap: 4px;

    & .info-offer {
      display: flex;
      align-items: center;
      gap: 4px;
      ${typography.body2bold}
      i {
        font-size: 20px;

        &.present-icon {
          font-size: 14px;
        }
        color: ${({ theme, mode }) =>
          mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
      }
    }

    & .info-spin {
      padding-left: 18px;
      ${typography.caption1regular}
      line-height: 14px;

      @media (${device.mobile}) {
        color: ${({ theme }) => hexToRGB(theme.white, 0.6)};
      }
    }

    a {
      text-decoration: underline;
    }

    .minDep-warning {
      ${typography.caption1regular};
      color: ${({ theme }) => theme.error};
      line-height: 14px;
    }
  }

  button {
    min-width: 93px;
  }

  & .error b {
    cursor: pointer;
  }
`;
